// extracted by mini-css-extract-plugin
module.exports = {"container":"SamplePage_container__8b8mY","chart":"SamplePage_chart__to8XU","faqBorder":"SamplePage_faqBorder__3AYvp","bannerWrapper":"SamplePage_bannerWrapper__DqqJS"};